/* eslint-disable @typescript-eslint/no-non-null-assertion */
export const isAuthenticated = () => JSON.parse(localStorage.getItem(`token`)!);
export const TOKEN = localStorage.getItem(`token`) ?? null;
export const INVESTOR = localStorage.getItem(`isInvestor`) ?? null;
export const ADVISOR = localStorage.getItem(`isAdvisor`) ?? null;
export const USERINFO = localStorage.getItem(`userInfo`) ?? null;
